<template>
 <div> 
    <div class="content">
      <div class="content-title">
        {{isModify ? '修改信息' : '员工注册'}}
      </div>
      <a-form-model ref="ruleForm" :rules="rules" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
          <div class="content-p">
              <span>基本信息</span>
           </div>
           <a-row>
               <a-col span="24" class="r-10">
                        <a-row>
                            <a-col :span="8">
                            <a-form-model-item label="姓名" prop="name">
                                    <a-input v-model.trim="form.name" class="w200" placeholder="以身份证为准"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                                <a-form-model-item label="手机号" prop="mobile">
                                    <a-input v-model.trim="form.mobile" class="w200"  placeholder="本人实名认证手机号"/>
                                </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                                <a-form-model-item label="邮箱" prop="email">
                                    <a-input v-model.trim="form.email" class="w200" placeholder="例：123456@163.com"/>
                                </a-form-model-item>
                        </a-col>
                    </a-row>
               </a-col>
                <a-col span="24" class="r-10">
                     <a-row>
                            <a-col :span="8">
                                <a-form-model-item label="民族" prop="nation">
                                    <a-select v-model="form.nation" placeholder="请选择" class="w200" showSearch allowClear>
                                        <a-select-option v-for="item in Cons.national" :value="item" :key="item">
                                        {{item}}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-model-item label="政治面貌" prop="perFace">
                                    <a-select v-model="form.perFace" placeholder="请选择" class="w200" allowClear>
                                        <a-select-option v-for="item in Cons.politicalOutlook" :value="item" :key="item">
                                            {{item}}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                        </a-col>
                     </a-row>  
                </a-col>   
                <a-col span="24" class="r-10">
                    <a-row>
                        <a-col :span="16">
                            <a-form-model-item label="身份证号" prop="cardid" :label-col="{span:5}" :wrapper-col="{span: 19}">
                                 <a-input v-model.trim="form.cardid" class="w596" placeholder="" @change="handleCardIdChange" :disabled="isModify"/>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </a-col>
              
               <a-col :span="24" v-if="verifyCardId">
                    <div class="child-form-item">
                        <a-row class="no-prompt">
                            <a-col :span="8">
                                <a-form-model-item label="出生日期" prop="birth" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                    <a-date-picker v-model="form.birth" class="w200" :disabled="true" placeholder=""/>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-model-item label="性别" prop="sex" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                    <a-radio-group v-model="form.sex" name="radioGroup" :default-value="1" :disabled="true">
                                        <a-radio :value="1">男</a-radio>
                                        <a-radio :value="0">女</a-radio>
                                    </a-radio-group>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8" class="last">
                                <a-form-model-item label="籍贯" prop="native" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                    <a-select v-model="form.native" placeholder="请选择" class="w200"  v-if="!isModify">
                                        <a-select-option :value="key" v-for="(value, key) in Cons.province" :key="key">
                                         {{value}}
                                        </a-select-option>
                                    </a-select>
                                   <a-input v-else v-model.trim="form.native" class="w200" placeholder="" :disabled="true"/>
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                    </div>
               </a-col>
                <a-col :span="16">
                    <a-form-model-item class="upload-file-form" label="上传证件" prop="name" validateStatus="success" :label-col="{span:5}" :wrapper-col="{span: 19}"  style="margin-bottom:0;">
                       <div class="id-card-con">
                          <div class="prompt">仅支持Jpg、Png格式； 证件照片要求: 宽356像素，高441像素，白底、彩色，露眉露耳（使用高质量图片，可生成高清头像）</div> 
                          <div class="upload-con">
                               <a-form-model-item label=""  prop="photo" :label-col="{span:0}" :wrapper-col="{span: 24}">
                                  <div class="item">
                                    <a-upload
                                            name="file"
                                            :action="regAPI.uploadUrl"
                                            :showUploadList="false"
                                            :headers="{}"
                                            :beforeUpload="handleBeforeUpload"
                                            @change="handleUploadChange($event, 'photo')"
                                        >
                                            <div class="upload-btn" :class="{'upload-btn-active': !!form.photo}">
                                                <template v-if="!form.photo">
                                                    <img class="upload-btn-img" src="../assets/3.png" alt="">
                                                    <div class="upload-btn-text">上传证件照</div>         
                                                </template>
                                                <template v-else>
                                                    <div class="uploaded-img">
                                                        <img :src="config.uploadImgUrl + '/' +form.photo" alt="">
                                                        <div class="text">证件照</div>   
                                                    </div>
                                                </template>
                                            </div>
                                        </a-upload>
                                        <div class="close" v-if="form.photo" @click="handleDeleteFile('photo')">
                                            <img class="close-img" src="../assets/close.png" alt="">
                                        </div>
                                    </div>
                              </a-form-model-item>
                              <a-form-model-item label=""  prop="cardid_f_img"  :label-col="{span:0}" :wrapper-col="{span: 24}">
                                <div class="item">
                                    <a-upload
                                            name="file"
                                            :action="regAPI.uploadUrl"
                                            :showUploadList="false"
                                            :headers="{}"
                                            :beforeUpload="handleBeforeUpload"
                                            @change="handleUploadChange($event, 'cardid_f_img')"
                                        >
                                            <div class="upload-btn" :class="{'upload-btn-active': !!form.cardid_f_img}">
                                                <template v-if="!form.cardid_f_img">
                                                    <img class="upload-btn-img" src="../assets/3.png" alt="">
                                                    <div class="upload-btn-text">上传身份证(正面)</div>
                                                </template>
                                                <template v-else>
                                                    <div class="uploaded-img">
                                                        <img :src="config.uploadImgUrl + '/' +form.cardid_f_img" alt="">
                                                        <div class="text">身份证(正面)</div>   
                                                    </div>
                                                </template>
                                            </div>
                                        </a-upload>
                                        <div class="close" v-if="form.cardid_f_img" @click="handleDeleteFile('cardid_f_img')">
                                            <img class="close-img" src="../assets/close.png" alt="">
                                        </div>
                                </div>
                              </a-form-model-item>
                             <a-form-model-item label="" prop="cardid_b_img" :label-col="{span:0}" :wrapper-col="{span: 24}">
                                    <div class="item">
                                        <a-upload
                                                name="file"
                                                :action="regAPI.uploadUrl"
                                                :showUploadList="false"
                                                :headers="{}"
                                                :beforeUpload="handleBeforeUpload"
                                                @change="handleUploadChange($event, 'cardid_b_img')"
                                            >
                                                <div class="upload-btn" :class="{'upload-btn-active': !!form.cardid_b_img}">
                                                    <template v-if="!form.cardid_b_img">
                                                            <img class="upload-btn-img" src="../assets/3.png" alt="">
                                                            <div class="upload-btn-text">上传身份证(反面)</div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="uploaded-img">
                                                            <img :src="config.uploadImgUrl + '/' +form.cardid_b_img" alt="">
                                                            <div class="text">身份证(反面)</div>   
                                                        </div>
                                                    </template>
                                                </div>
                                            </a-upload>
                                            <div class="close" v-if="form.cardid_b_img"  @click="handleDeleteFile('cardid_b_img')">
                                                <img class="close-img" src="../assets/close.png" alt="">
                                            </div>
                                    </div>
                              </a-form-model-item>
                          </div>
                       </div>
                    </a-form-model-item>
              </a-col>   
              <a-col :span="16">
                   <a-form-model-item label="学历信息" prop="eduinfo" :label-col="{span:5}" :wrapper-col="{span: 19}" style="margin-bottom:10px;">
                        <a-radio-group name="radioGroup" v-model="form.eduinfo" @change="handleEduInfoChange">
                            <a-radio :value="1">实习</a-radio>
                            <a-radio :value="2">毕业</a-radio>
                            <a-radio :value="3">退伍</a-radio>
                        </a-radio-group>
                    </a-form-model-item>
              </a-col>  
              <a-col :span="24" v-if="form.eduinfo">
                    <div class="child-form-item">
                        <template v-if="form.eduinfo === 1 || form.eduinfo === 2">
                            <div>
                                <a-row>
                                    <a-col :span="8">
                                        <a-form-model-item label="学历" prop="edc" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                            <a-select v-model="form.edc" placeholder="请选择最高学历" class="w200" allowClear>
                                                <a-select-option :value="item" v-for="item in educationList" :key="item">
                                                  {{item}}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item label="专业" prop="major" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                            <a-input v-model="form.major" class="w200" placeholder="以学信网/民教网信息为准"/>
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8" class="last">
                                        <a-form-model-item label="毕业院校" prop="college" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                             <a-input v-model="form.college" class="w200" placeholder="以学信网/民教网信息为准"/>
                                        </a-form-model-item>
                                    </a-col>
                                </a-row>
                                <a-row class="no-prompt">
                                    <a-col :span="8">
                                        <a-form-model-item label="入学时间" prop="entranceDate" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                            <a-select v-model="form.entranceDate" placeholder="以学信网/民教网信息为准" class="w200" allowClear v-if="form.eduinfo === 1">
                                                <a-select-option :value="item" v-for="item in beforeYear" :key="item">
                                                  {{item}}
                                                </a-select-option>
                                            </a-select>   
                                             <a-date-picker v-else class="w200" placeholder="以学信网/民教网信息为准" v-model="form.entranceDate" @change="handleEntranceDateChange"/>
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item label="毕业时间" prop="gd" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                             <a-select v-model="form.gd" placeholder="以学信网/民教网信息为准" class="w200" allowClear v-if="form.eduinfo === 1">
                                                <a-select-option :value="item" v-for="item in afterYear" :key="item">
                                                  {{item}}
                                                </a-select-option>
                                            </a-select>   
                                            <a-date-picker v-else v-model="form.gd" placeholder="以学信网/民教网信息为准" class="w200"  :disabled-date="disabledGDDate"/>
                                        </a-form-model-item>
                                    </a-col>
                                </a-row>
                            </div>
                        </template>
                        <template  v-if="form.eduinfo === 3">
                             <div>
                                <a-row>
                                    <a-col :span="8">
                                        <a-form-model-item label="身份" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                            {{ form.edc }}
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item label="兵种" prop="major" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                            <a-select v-model="form.major" placeholder="以退伍证信息为准" class="w200" allowClear>
                                                <a-select-option :value="item" v-for="item in Cons.arms" :key="item">
                                                 {{item}}
                                                </a-select-option>
                                            </a-select>
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8" class="last">
                                        <a-form-model-item label="部队名称" prop="college" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                             <a-input v-model.trim="form.college" class="w200" placeholder="以退伍证信息为准"/>
                                        </a-form-model-item>
                                    </a-col>
                                </a-row>
                                <a-row class="no-prompt">
                                    <a-col :span="8">
                                        <a-form-model-item label="入伍时间" prop="entranceDate" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                            <a-date-picker class="w200" placeholder="以退伍证信息为准" v-model="form.entranceDate" @change="handleEntranceDateChange"/>
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item label="退伍时间" prop="gd" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                            <a-date-picker placeholder="以退伍证信息为准" class="w200" v-model="form.gd" :disabled-date="disabledGDDate"/>
                                        </a-form-model-item>
                                    </a-col>
                                </a-row>
                            </div>
                        </template>
                        
                    </div>
             </a-col> 
              <a-col :span="16" v-if="form.eduinfo">
                    <a-form-model-item label="上传证明" prop="edc_img" :label-col="{span:5}" :wrapper-col="{span: 19}">
                       <div class="id-card-con">
                          <div class="prompt">仅支持jpg、Png格式； 学历证明要求：学信网带二维码的截图。</div> 
                          <div class="upload-con">
                             <div class="item">
                                   <a-upload
                                         name="file"
                                        :action="regAPI.uploadUrl"
                                        :showUploadList="false"
                                        :headers="{}"
                                        :beforeUpload="handleBeforeUpload"
                                        @change="handleUploadChange($event, 'edc_img')"
                                    >
                                        <div class="upload-btn" :class="{'upload-btn-active': !!form.edc_img}">
                                            <template v-if="!form.edc_img">
                                                <img class="upload-btn-img" src="../assets/3.png" alt="">
                                                <div class="upload-btn-text">上传{{form.eduinfo === 3? '退伍证明': "学历证明"}}</div>
                                             </template>
                                            <template v-else>
                                                <div class="uploaded-img">
                                                    <img :src="config.uploadImgUrl+ '/' +form.edc_img" alt="">
                                                     <div class="text">{{form.eduinfo === 3? '退伍证明': "学历证明"}}</div>   
                                                </div>
                                            </template>
                                        </div>
                                    </a-upload>
                                    <div class="close"  v-if="form.edc_img" @click="handleDeleteFile('edc_img')">
                                        <img class="close-img" src="../assets/close.png" alt="">
                                    </div>
                             </div>
                          </div>
                       </div>
                    
                    </a-form-model-item>
              </a-col> 
              <a-col :span="16">
                    <a-form-model-item label="在京住址" prop="addr" :label-col="{span:5}" :wrapper-col="{span: 19}">
                        <a-input v-model.trim="form.addr"  placeholder="详细到门牌号，最少12个字"  class="w596"/>
                    </a-form-model-item>
               </a-col>
               <a-col :span="16">
                    <a-form-model-item label="老家住址" prop="homeaddr" :label-col="{span:5}" :wrapper-col="{span: 19}">
                        <a-input v-model.trim="form.homeaddr" placeholder="详细到门牌号，最少12个字"  class="w596"/>
                    </a-form-model-item>
               </a-col>
               <a-col :span="16" >
                    <a-form-model-item  class="emergency-contact"  prop="name" label="紧急联系人"  :label-col="{span:5}" :wrapper-col="{span: 19}" style="margin-bottom:0;">
                        <a-row :gutter="8" style="width:604px" class="emergency-contact-item">
                            <a-col :span="8">
                                <a-form-model-item label="" prop="hname" :label-col="{span:0}" :wrapper-col="{span: 24}">
                                    <a-input v-model.trim="form.hname" placeholder="请输入姓名"/>
                                 </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                 <a-form-model-item label="" prop="hralation" :label-col="{span:0}" :wrapper-col="{span: 24}">
                                    <a-select v-model="form.hralation" placeholder="与紧急联系人关系" allowClear>
                                        <a-select-option :value="item" v-for="item in Cons.liaison" :key="item">{{item}}</a-select-option>
                                    </a-select>
                                 </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                 <a-form-model-item label="" prop="htel" :label-col="{span:0}" :wrapper-col="{span: 24}">
                                       <a-input v-model="form.htel" placeholder="紧急联系人手机号"/>
                                 </a-form-model-item>
                            </a-col>
                        </a-row>
                    </a-form-model-item>
               </a-col>
                <a-col :span="16">
                    <a-form-model-item label="应聘职位" prop="job" :label-col="{span:5}" :wrapper-col="{span: 19}">
                        <a-select v-model="form.job" placeholder="请选择" allowClear @change="handleJobChange" style="width:193px;">
                            <a-select-option :value="item.value" v-for="item in Cons.applyPosition" :key="item.value">{{item.title}}</a-select-option>
                        </a-select>
                    </a-form-model-item>
               </a-col>
                <a-col :span="16" v-if="form.job === 10">
                    <a-form-model-item label="入职部门" :label-col="{span:5}" :wrapper-col="{span: 19}" style="margin-bottom:0;">
                        <a-row :gutter="8"  style="width:604px">
                            <a-col :span="8">
                                 <a-form-model-item label="" prop="bigarea" :label-col="{span:0}" :wrapper-col="{span: 24}">
                                    <a-select v-model="form.bigarea" placeholder="请选择"  :filter-option="filterOption" show-search allowClear @change="handleBigareaChange">
                                            <a-select-option :value="item.id" :key="item.id" v-for="item in bigAreaList">{{item.name}}</a-select-option>
                                    </a-select>
                                 </a-form-model-item> 
                            </a-col>
                            <a-col :span="8">
                                <a-select v-model="form.area" placeholder="请选择"  :filter-option="filterOption" showSearch allowClear @change="handleAreaChange">
                                        <a-select-option :value="item.id" :key="item.id"  v-for="item in areaList">{{item.name}}</a-select-option>
                                </a-select>
                            </a-col>
                            <a-col :span="8" style="position: relative;">
                                <a-select v-model="form.shop" placeholder="请选择" allowClear  @change="handleShopChange">
                                    <a-select-option :value="item.id" v-for="item in shopList" :key="item.id">{{item.name}}</a-select-option>
                                </a-select>
                                <div class="shop-leader" v-if="form.shop && shopObj">
                                        店长: {{shopObj.name}}
                                 </div>
                            </a-col>
                             
                        </a-row>
                      
                    </a-form-model-item>
               </a-col>
               <a-col :span="16">
                    <a-form-model-item label="招聘来源" prop="jobsource" :label-col="{span:5}" :wrapper-col="{span: 19}" :style="{'margin-bottom': form.jobsource === '内部推荐' ?'18px': ''}">
                        <a-select v-model="form.jobsource" placeholder="请选择"  allowClear  style="width:193px;" @change="handleJobsourceChange">
                            <a-select-option :value="item" v-for="item in Cons.recruitmentSource" :key="item">{{item}}</a-select-option>
                        </a-select>
                    </a-form-model-item>
               </a-col>
                <a-col :span="24" v-if="form.jobsource === '内部推荐'">
                    <div class="child-form-item">
                        <a-row class="no-prompt">
                            <a-col :span="8">
                                <a-form-model-item label="分店/部门" prop="jobdept" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                    <!-- <a-input v-model="form.jobdept" placeholder="请输入" class="w200"/> -->
                                    <a-select 
                                    :dropdownMatchSelectWidth="false"
                                    :default-active-first-option="false"
                                    :show-arrow="false"
                                    :filter-option="false"
                                    :not-found-content="searchLoading ? undefined : null"
                                     class="w200" show-search 
                                     v-model="form.jobdept" 
                                     placeholder="请输入" 
                                     @search="handleJobDeptSearch" 
                                     @change="handleJobDeptChange" allowClear>
                                        <a-spin v-if="searchLoading" slot="notFoundContent" size="small" />
                                        <a-select-option v-for="d in jobDeptList" :key="d.value" >
                                              {{ d.name }}
                                        </a-select-option>
                                    </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                    <a-form-model-item label="转介绍人" prop="selIntroper" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                        <a-select v-model="form.selIntroper" placeholder="请选择"  class="w200" allowClear>
                                            <a-select-option :value="item.name" v-for="item in introducerList" :key="item.id">
                                             {{ item.name}}
                                            </a-select-option>
                                        </a-select>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8" class="last introduce-phone">
                                <a-form-model-item label="转介绍人电话" prop="jobtel" :label-col="{span: 6}" :wrapper-col="{span: 16}">
                                  <a-input v-model="form.jobtel" placeholder="请输入" class="w200"/>
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                    </div>
               </a-col>
                <a-col :span="16">
                   <a-form-model-item label="房产经纪人从业经验" prop="industryExperience" :label-col="{span:5}" :wrapper-col="{span: 19}">
                        <a-radio-group name="radioGroup"  v-model="form.industryExperience">
                            <a-radio :value="1">有</a-radio>
                            <a-radio :value="0">无</a-radio>
                        </a-radio-group>
                    </a-form-model-item>
                </a-col> 
                <a-col :span="16">
                   <a-form-model-item label="工作履历" :label-col="{span:5}" :wrapper-col="{span: 19}" style="margin-bottom:0;">
                       <div class="exp">
                           <div class="exp-item" v-for="(item,index) in form.works" :key="index">
                               <div class="time">
                                    <a-form-model-item label=""  :prop="'works.' + index + '.time'" :label-col="{span:0}" :wrapper-col="{span: 24}">
                                     <a-range-picker v-model="item.time"  :placeholder="['开始时间', '结束时间']"  style="width:228px;"/>
                                    </a-form-model-item>
                               </div>
                               <div class="company">
                                    <a-form-model-item label=""  :prop="'works.' + index + '.wdw'" :label-col="{span:0}" :wrapper-col="{span: 24}">
                                         <a-input style="width:188px;" v-model.trim="item.wdw"  placeholder="单位名称"/>
                                 </a-form-model-item>
                               </div>
                               <div class="depart">
                                    <a-form-model-item label=""  :prop="'works.' + index + '.wjob'" :label-col="{span:0}" :wrapper-col="{span: 24}">
                                     <a-input style="width:116px;" v-model.trim="item.wjob"  placeholder="职务"/>
                                    </a-form-model-item>
                               </div>
                                <div class="num">
                                    <a-form-model-item label=""  :prop="'works.' + index + '.wsalary'" :label-col="{span:0}" :wrapper-col="{span: 24}">
                                      <a-input-number  style="width:116px;"  placeholder="薪资"  :precision="0" v-model="item.wsalary"  :min="0" />
                                    </a-form-model-item>
                               </div>
                                <div class="phone">
                                        <a-form-model-item label=""  :prop="'works.' + index + '.wtel'" :rules="[{validator:isPhone}]" :label-col="{span:0}" :wrapper-col="{span: 24}">
                                             <a-input style="width:116px;" v-model="item.wtel"  placeholder="证明电话"/>
                                        </a-form-model-item>
                               </div>
                               <div class="reason">
                                   <a-input style="width:188px;" v-model.trim="item.wlz"  placeholder="离职原因"/>
                               </div>
                               <div class="opt">
                                   <img src="../assets/add.png" alt="" v-if="form.works.length - 1 === index && index !== 2" @click="handleAddWork">
                                   <img src="../assets/remove.png" alt="" v-else @click="handleRemoveWork(index)">
                               </div>
                           </div>
                       </div>
                    </a-form-model-item>
              </a-col> 

           </a-row>
           <div class="content-p content-p-other">
              <span>其他信息</span>
           </div>
           <a-row>
                <a-col :span="16">
                   <a-form-model-item label="健康状况" prop="health" :label-col="{span:5}" :wrapper-col="{span: 19}">
                       <div style="width:900px;">
                            <a-radio-group name="radioGroup" v-model="form.health" @change="form.sks = null">
                                <a-radio :value="1">有重大疾病/手术记录</a-radio>
                                <a-radio :value="0">无重大疾病/手术记录</a-radio>
                             </a-radio-group>
                       </div>
                    </a-form-model-item>
                    <div class="fall-wrap" v-if="form.health === 1">
                        <a-form-model-item label="病名" prop="sks" :label-col="{span: 6}" :wrapper-col="{span: 18}">
                            <div class="fall">
                                <a-input  class="w200" v-model="form.sks"  placeholder=""/>
                            </div>
                        </a-form-model-item>
                     </div>
                </a-col> 
                <a-col :span="16">
                    <a-form-model-item label="婚姻状况" prop="marriage" :label-col="{span:5}" :wrapper-col="{span: 19}">
                        <a-radio-group name="radioGroup" v-model="form.marriage">
                            <a-radio :value="0">未婚</a-radio>
                            <a-radio :value="1">已婚</a-radio>
                        </a-radio-group>
                    </a-form-model-item>
               </a-col>
                <a-col span="24" class="r-10">
                        <a-row>
                            <a-col :span="8">
                            <a-form-model-item label="户口所在地" prop="hkaddr" >
                                <a-cascader v-if="!isModify" :options="areaOptions" v-model="form.hkaddr"  class="w200" allowClear :load-data="areaLoadData" placeholder="请选择"/>   
                                <a-input v-else class="w200"  v-model.trim="form.hkaddr"  placeholder="请输入"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                                <a-form-model-item label="户口性质" prop="category">
                                    <a-select v-model="form.category" placeholder="请选择" allowClear class="w200">
                                            <a-select-option :value="item"  v-for="item in Cons.addressType" :key="item">{{item}}</a-select-option>
                                     </a-select>
                                </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                        </a-col>
                    </a-row>
               </a-col>
                <a-col span="24" class="r-10">
                        <a-row>
                            <a-col :span="8">
                            <a-form-model-item label="身高(CM)" prop="per_cm">
                                   <a-input v-model.trim="form.name" class="w200" v-model="form.per_cm" @change="perCmChange"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                                <a-form-model-item label="体重(KG)" prop="per_kg">
                                    <a-input v-model.trim="form.name" class="w200" v-model="form.per_kg" @change="perKgChange"/>
                                </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                        </a-col>
                    </a-row>
               </a-col>
               <a-col :span="16">
                    <a-form-model-item label="本人承诺" prop="cn" :label-col="{span:5}" :wrapper-col="{span: 19}">
                        <a-radio @click="form.cn = !form.cn" :checked="form.cn">本人无不良记录/犯罪记录</a-radio>
                    </a-form-model-item>
               </a-col>
                <a-col :span="16">
                    <a-form-model-item label="验证码" prop="code" :label-col="{span:5}" :wrapper-col="{span: 19}">
                         <a-input v-model.trim="form.code" class="w200" placeholder="请输入"/>
                         <div class="code" @click="handleCodeLink">
                            <img :src="codeLink" alt="">
                         </div>
                    </a-form-model-item>
               </a-col>
               <a-col :span="16">
                      <div class="prompt">该密码将会再次使用，请谨慎保存</div>
                </a-col>
               <a-col :span="16" v-if="!isModify">
                    <a-form-model-item label="密码" prop="pwd" :label-col="{span:5}" :wrapper-col="{span: 19}" >
                         <a-input v-model.trim="form.pwd" class="w200" placeholder="请输入" type="password"/>
                        <div class="tip">{{  tiocon }}</div> 
                    </a-form-model-item>
               </a-col>
               <a-col :span="16" v-if="!isModify">
                    <a-form-model-item label="确认密码" prop="confirmpwd" :label-col="{span:5}" :wrapper-col="{span: 19}">
                         <a-input v-model.trim="form.confirmpwd" class="w200" placeholder="请再次确认上面的密码" type="password"/>
                    </a-form-model-item>
               </a-col>
           </a-row>
           <div class="sub-btn">
               <a-row>
                  <a-col :span="16">
                    <a-form-model-item label="1" :label-col="{span:5}" :wrapper-col="{span: 19}">
                         <a-button type="primary" :loading="subLoading" @click="handleSub" :disabled="!form.cn">提交</a-button>
                    </a-form-model-item>
               </a-col>
               </a-row>
           </div>
     </a-form-model>
    </div>
    <!-- 弹窗 -->
     <a-modal
      title="个人注册"
      :closable="false"
      :width="700"
      :visible="visible"
      :maskClosable="false"
    >
      <div class="reg-suc"> 
          <img src="../assets/bulb.jpeg" alt="">
          <div class="text">
            您好，您已注册成功！组训审核后方可打印注册信息，人事报到需要携带入职申请表、身份证复印件、学历证明！<br/>
            用户名为：{{userInfo.id}}<br/>
            用户密码为：{{form.pwd}} <br/>
            请牢记您的用户名和密码。
          </div>
      </div>
      <div slot="footer">
          <a-button type="primary" @click="handleRegSncSure">确定</a-button>
      </div>
    </a-modal>
 </div>
</template>
<script>
import PCA from 'area-data/pca'
import moment from 'moment'
import Cons from '../constant/register'
import { isPhone, isEamil, isIdCard, minLength, hasPhone, hasEmail, hasIdCard, hasIdCardAdmission,isPositiveInteger} from '../utils/validator'
import { vaildIdCard } from '../utils/tools'
import { regAPI } from '@/api'
const uploadFileType = ['jpg', 'png']
import { message } from 'ant-design-vue';
import config from '@/config/index'
let timeout = null
const sucCode = ['200000']
let tiocon = '8-16位数字+字母+特殊字符( !@#$%^&*()_=+{};:,<.>?/|~ )组合'
export default {
    data(){
        // 【紧急联系人姓名】不能与【姓名】相同
        let emergencyContactName = (rule, value, callback) => {
            if(this.form.name === value) {
                callback(new Error('不能与本人姓名相同'))
            } else {
                callback()
            }
           
        }
        // 【紧急联系人手机号码】不能与【手机】相同
        let emergencyContactPhone = (rule, value, callback) => {
            if(this.form.mobile === value) {
                callback(new Error('不能与本人手机号相同'))
            } else {
                callback()
            }
           
        }
        // 限量 低学历判断 
        let limitEdu = (rule, value, callback) => {
            if (!value) {
                return callback()
            }
            if(!this.form.edc){
                this.form.bigarea = undefined
                this.areaList = []
                message.error('请先选择学历信息')
                return callback(new Error('请先选择学历信息'))
            }
            regAPI.verfiyHas({
                dg: this.form.edc,
                id: value,
                action: "dlimit"
            }).then(res => {
                if(!sucCode.includes(res.code)){
                    callback(new Error(res.msg))
                } else {
                    callback()
                }
            })
           
        }
        // 编辑时候校验排除自己信息的接口
        let verifyExcludeSelf = {
            'mobile': (rule, value, callback) => {
                if(this.initForm.mobile ===  this.form.mobile){
                    callback()  
                }  else {
                    hasPhone(rule, value, callback)
                }
            },
            'email': (rule, value, callback) => {
                if(this.initForm.email ===  this.form.email){
                    callback()  
                }  else {
                    hasEmail(rule, value, callback)
                }
            },
            'limitEdu': (rule, value, callback) => {
                 if(this.initForm.edc ===  this.form.edc && this.initForm.bigarea === this.form.bigarea){
                    callback()  
                }  else {
                    limitEdu(rule, value, callback)
                }
            },
            'hkaddr':  '请输入户口所在地'
        }
        // 校验密码规则
        let verifypwdRule = (rule, value, callback) => {
            // let len = value.length
            // if(len < 8 || len > 16){
            //     return callback(new Error('密码由8-16位数字加字母加特殊字符组合！'))
            // }
            // 使用正则表达式检查密码是否包含数字、大写字母和特殊字符
            var regex = /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*()_=+{};:,<.>?/|~])[0-9a-zA-Z!@#$%^&*()_=+{};:,<.>?/|~]{8,16}$/;
            if (!regex.test(value)) {
                return callback(new Error(tiocon))
            } 
            callback()
        }
        // 校验确认密码是否一致
        let verifyConfirmpwd = (rule, value, callback) => {
            if(value !== this.form.pwd){
                return callback(new Error('确认密码和密码不一致'))
            }
            callback()
        }
        return {
            regAPI,
            form: {
                works: [{time:[null, null]}],
                industryExperience: undefined,
                edc: undefined,
                major:undefined,
                college:undefined,
                entranceDate:undefined,
                gd:undefined,
                bigarea: undefined,
                area: undefined,
                shop: undefined,
                jobdept: undefined,
                selIntroper: undefined,
                jobtel:undefined,
                health: undefined,
                marriage: undefined,
                cn: false,
                photo: undefined,
                cardid_f_img: undefined,
                cardid_b_img: undefined,
                edc_img: undefined,
                native: undefined,
                sks: undefined,
                jobsource: undefined,
                pwd: undefined,
                confirmpwd: undefined
            },
            Cons,
            labelCol: { span: 10 },
            wrapperCol: { span: 14 },
            rules: {
                name: [
                    {required: true, message: '请输入姓名'}
                ],
                mobile: [
                    {required: true, message: '请输入手机号'},
                    {validator: isPhone},
                    {validator: hasPhone}
                ],
                email: [
                    {required: true, message: '请输入邮箱'},
                    {validator: isEamil, trigger: 'blur'},
                    {validator: hasEmail, trigger: 'blur'},
                ],
                nation: [
                    {required: true, message: '请选择民族'},
                ],
                perFace: [
                    {required: true, message: '请选择政治面貌'},
                ],
                cardid: [
                    {required: true, message: '请输入身份证'},
                    {validator: isIdCard},
                    {validator: hasIdCard},
                    {validator: hasIdCardAdmission}
                ],
                eduinfo: [
                    {required: true, message: '请选择学历信息'},
                ],
                edc: [
                    {required: true, message: '请选择学历'},
                ],
                major: [
                    {required: true, message: '请输入专业'},
                ],
                college: [
                    {required: true, message: '请输入毕业院校'},
                ],
                entranceDate: [
                    {required: true, message: '请选择入学时间'},
                ],
                gd: [
                    {required: true, message: '请选择毕业时间'},
                ],
                addr: [
                     {required: true, message: '请输入在京住址'},
                     {validator: minLength, min: 12, msg: '在京住址'}
                ],
                homeaddr: [
                     {required: true, message: '请输入老家住址'},
                     {validator: minLength, min: 12, msg: '老家住址'}
                ],
                hname: [
                     {required: true, message: '请输入紧急联系人姓名'},
                     {validator: emergencyContactName}
                ],
                hralation: [
                    {required: true, message: '请选择与紧急联系人关系'},
                ],
                htel: [
                    {required: true, message: '请输入紧急联系人手机号'},
                    {validator: isPhone},
                    {validator: emergencyContactPhone}
                ],
                job: [
                    {required: true, message: '请选择应聘职位'},
                ],
                jobdept: [
                     {required: true, message: '请选择分店/部门'},
                ],
                jobtel: [
                     {required: true, message: '请输入介绍人电话'},
                     {validator: isPhone}
                ],
                industryExperience: [
                     {required: true, message: '请选择房产经纪人从业经验'},
                ],
                health: [
                     {required: true, message: '请选择健康状况'},
                ],
                sks: [
                     {required: true, message: '请输入病名'},
                ],
                marriage: [
                     {required: true, message: '请选择婚姻状况'},
                ],
                hkaddr: [
                     {required: true, message: '请选择户口所在地'},
                ],
                category: [
                     {required: true, message: '请选择户口性质'},
                ],
                per_cm: [
                     {required: true, message: '请输入身高'},
                      {validator: isPositiveInteger}
                ],
                per_kg: [
                    {required: true, message: '请输入体重'},
                     {validator: isPositiveInteger}
                ],
                photo: [
                    {required: true, message: '请上传证件照'},
                ],
                cardid_f_img: [
                    {required: true, message: '请上传身份证(正面)'},
                ],
                cardid_b_img: [
                    {required: true, message: '请上传身份证(反面)'},
                ],
                edc_img: [
                    {required: true, message: '请上传证明'},
                ],
                jobsource: [
                    {required: true, message: '请选择招聘来源', trigger: 'change'},
                ],
                bigarea: [
                    {validator: limitEdu}
                ],
                cn: [
                     {required: true, message: ''},
                ],
                code: [
                     {required: true, message: '请输入验证码'},
                ],
                pwd: [
                     {required: true, message: '请输入密码'},
                     {validator: verifypwdRule}
                ],
                confirmpwd: [
                    {required: true, message: '请输入确认密码'},
                    {validator: verifyConfirmpwd}
                ]
            },
            // 省市
            areaOptions: [],
            verifyCardId: false,
            // 年份（含）往后推6年
            afterYear: [],
            //  年份（含）往前推6年
            beforeYear: [],
            subLoading: false,
            codeLink: '',
            jobDeptList: [],
            searchJobDeptKey: '',
            visible: false,
            bigAreaList: [],
            areaList: [],
            shopList: [],
            shopObj: null,
            initForm: {},
            verifyExcludeSelf,
            introducerList: [],
            isModify: false,
            userInfo: {},
            config,
            systemTime: '',
            searchLoading: false,
            tiocon
        }
    },
    computed: {
        educationList(){
            if(this.form.eduinfo === 2){
                return  Cons.education
            } else {
                return  Cons.education.filter(item => !['自考本科','自考大专'].includes(item) )
            }
        }
    },
   async mounted(){
        let time =  await regAPI.commonAPI({ action: 'GetServerDate'})
        this.systemTime = (time.data && time.data[0].name) || ''
        this.getProvince()
        this.getAfterYear()
        this.handleCodeLink()
        let {u, p} = this.$route.query
        if(u&&p){
            this.isModify = true
            this.userInfo = {
                user: u,
                pwd: p
            }
            this.initData()
        }
    },
    methods: {
        isPhone,
        initData(){
            this.rules['mobile'][2].validator = this.verifyExcludeSelf['mobile']
            this.rules['email'][2].validator =  this.verifyExcludeSelf['email']
            this.rules['bigarea'][0].validator = this.verifyExcludeSelf['bigarea']
            this.rules['hkaddr'][0].message = this.verifyExcludeSelf['hkaddr']
            this.rules['cardid'].splice(2,2)
            console.log( this.rules)
            this.verifyCardId = true
            regAPI.getData({
                type: 1,
                ...this.userInfo
            }).then((res) => {
                let initForm = res.data[0]
                let form = Object.assign({}, this.$options.data().form, JSON.parse(JSON.stringify(initForm))) 
                form.sex = form.sex === 'True' ? 1: 0
                form.marriage = form.marriage === 'True' ? 1: 0
                if(form.practice === 'True') {
                    form.eduinfo = 1 
                    form.entranceDate = (form.entranceDate && form.entranceDate.substring(0,4)) || undefined
                    form.gd = (form.gd && form.gd.substring(0,4)) || undefined
                    form.eduImgType = 2
                } else if(form.soldier === 'True'){
                    form.entranceDate = (form.entranceDate && moment(form.entranceDate.trim()))
                    form.gd = (form.gd && moment(form.gd.trim()))
                    form.eduinfo = 3
                    form.eduImgType = 3
                } else {
                    form.eduinfo = 2
                    form.eduImgType = 2
                    form.entranceDate = (form.entranceDate && moment(form.entranceDate.trim()))
                    form.gd = (form.gd && moment(form.gd.trim()))
                }
                if(form.jobsource === '内部推荐'){
                    let deptArr = form.jobinfo.split(':')
                    form.jobtel = deptArr[3]
                    form.selIntroper = deptArr[2]
                    this.searchJobDeptKey = deptArr[1]
                }
                form.health = form.sks ? 1:0
                form.industryExperience = Number(form.industryExperience)
                if(form.works && form.works.length > 0) {
                    form.works.forEach(item => {
                        item.time = (item.wbegindate && item.wenddate && [moment(item.wbegindate), moment(item.wenddate)]) || [null, null]
                    })
                } else {
                    form.works = [{time:[null, null]}]
                }
                form.job = Number(form.job) 
                form.birth = moment(form.birth)
                let members = form.members[0] || {}
                form.hname = members.hname,
                form.hralation =  members.hralation,
                form.htel = members.htel
                form.cn = null
                form.bigarea =  (form.bigarea && form.bigarea!=='0') ? form.bigarea :  undefined 
                form.area =  (form.area && form.area!=='0') ? form.area :  undefined 
                form.shop =  (form.shop && form.shop!=='0') ? form.shop :  undefined 
                this.form = form
                if(form.jobsource === '内部推荐' && this.searchJobDeptKey){
                    this.getJobDept(true)
                }
                this.getBigArea(form.job)
                this.getArea()
                this.getShop()
                this.getShopLeader()
                this.initForm = JSON.parse(JSON.stringify(initForm))
                this.rules.major[0].message = form.eduinfo !== 3  ? '请输入专业': '请选择兵种'
                this.rules.college[0].message =  form.eduinfo !== 3  ? '请输入毕业院校': '请输入部队名称'
                this.rules.entranceDate[0].message =  form.eduinfo !== 3  ? '请选择入学时间': '请选择入伍时间'
                this.rules.gd[0].message =  form.eduinfo !== 3  ? '请选择毕业时间': '请选择退伍时间'
            }).catch(() => {
                // message.error('获取用户信息失败')
            })
           
        },
        // 
        perCmChange (e) {
           this.form.per_cm = (e.target.value.match(/^\d{0,3}/g)[0]) || null
        },
        perKgChange(e){
           this.form.per_kg = (e.target.value.match(/^\d{0,3}/g)[0]) || null
        },
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        // 删除文件
        handleDeleteFile(type){
            this.form[type] = ''
        },
        // 验证码切换
        handleCodeLink(){
           this.codeLink = config.APIUrl + '/Verifi_pic.ashx?date=' + new Date().toString()
        },
        handleUploadChange(data, key){
            console.log(data)
            if(data.file && (data.file.percent !== 100)){
                return false
            }
            if(data.file.response) {
                if(data.file.response.code !== '200') {
                    message.error(data.file.response.msg || '系统错误')
                } else {
                    this.$set(this.form, key,  data.file.response.src)
                    this.$nextTick(() => {
                        this.$refs.ruleForm.clearValidate([key])
                    })
                }
              
            }
        },
        // 上传前
        handleBeforeUpload(file){
            const findTypeIndex = file.name.lastIndexOf('.')
            const fileType = file.name.substring(findTypeIndex + 1).toLowerCase()
            console.log(fileType,uploadFileType)
            if(!uploadFileType.includes(fileType)){
                message.error('请上传Jpg、Png格式')
                return false
            }
            return true
        },
        // 切换招聘来源
        handleJobsourceChange(){
            Object.assign(this.form, {
                jobdept: undefined,
                selIntroper: undefined,
                jobtel: undefined
            })
             this.jobDeptList = []
             this.introducerList = []
        },
        // 模糊搜索部门
        handleJobDeptSearch(value){
            console.log(value)
            this.searchJobDeptKey = value
            this.jobDeptList = []
            this.getJobDept()
        },
        // 切换部门
        handleJobDeptChange(value){
            console.log(value, 'valuevaluevaluevaluevaluevaluevalue')
             Object.assign(this.form, {
                jobdept: value
            });
            this.form.selIntroper = undefined
            this.getIntroducer()
        },
        //获取转介绍人
        getIntroducer(){
            console.log(this.form.jobdept)
            if(!this.form.jobdept){
                this.introducerList = []
                return false
            }
            regAPI.commonAPI({
                id: this.form.jobdept.split('&&')[0],
                action: 'IntroShop',
            }).then((res) => {
                console.log(res.data)
                this.introducerList = res.data
            }).catch(() => {
                this.introducerList = []
            })
        },
        
        // 获取部门
        getJobDept(isInit){
            if(timeout){
                clearTimeout(timeout)
                timeout = null
            }
            this.searchLoading = true
            let the = this
            function getList(){
                regAPI.commonAPI({
                    q:  the.searchJobDeptKey,
                    limit: 20,
                    timestamp: Date.now(),
                    action: 'ShopName',
                    s:  the.searchJobDeptKey,
                }).then((res) => {
                    the.jobDeptList =(res.data && res.data.map(item => {
                        return {
                            id: item.id,
                            value:  `${item.id}&&${item.name}`,
                            name: item.name
                        }
                    })) || []
                    if(the.isModify && isInit) {
                       let item = res.data.find(item => item.name === the.searchJobDeptKey)
                       the.form.jobdept = `${item.id}&&${item.name}`
                       the.getIntroducer()
                    }
                }).catch(() => {
                    the.jobDeptList = []
                }).then(() => {
                    the.searchLoading = false
                })
            }
            timeout = setTimeout(getList, 300)
         
        },
        // 切换店组
        handleShopChange(data){
            if(this.isModify && this.form.shop == this.initForm.shop && this.form.job == this.initForm.job){
                this.getShopLeader()
                return false
            }
            if(!data){
                this.shopObj = null
                return false
            }
            regAPI.commonAPI({
                action: "limit",
                shopId: data,
                postId: this.form.job
            }).then((res) => {
                console.log(res)
                this.getShopLeader()
                // this.bigAreaList = res.data
            }).catch(() => {
                this.shopObj = null
                this.form.shop = undefined
            })
        },
        // 获取店组长
        getShopLeader(){
            if(!this.form.shop){
                this.shopObj = null
                return false
            }
            regAPI.commonAPI({
                action: 'sgr',
                id: this.form.shop,
            }).then((res) => {
                console.log(res)
                if(res.data && res.data && res.data[0]){
                   this.shopObj = res.data && res.data[0]
                } else {
                   this.shopObj =  null
                   this.form.shop = undefined
                   message.error('暂未设置分店经理，请重新选择')
                }
                
            }).catch(() => {
                this.shopObj = null
            })
        },
        // 切换区域
        handleAreaChange(){
            Object.assign(this.form, {
                shop: undefined
            })
            this.getShop()
        },
        // 切换大区
        handleBigareaChange(){
            Object.assign(this.form, {
                area: undefined,
                shop: undefined
            })
            if(!this.form.edc){
                return false
            }
            this.shopList = []
            this.getArea()
        },
        // 切换应聘职位
        handleJobChange(data){
            Object.assign(this.form, {
                bigarea: undefined,
                area: undefined,
                shop: undefined
            })
            this.areaList = []
            this.shopList = []
            if(data === 10) {
               this.getBigArea(data)
            }
        },
        // 获取大区
        getBigArea(data){
            if(!data){
                this.bigAreaList = []
                return false
            }
            regAPI.commonAPI({
                id: data,
                action: 'bigarea'
            }).then((res) => {
                this.bigAreaList = res.data
            }).catch(() => {
                 this.bigAreaList = []
            })
        },
         // 获取区域
        getArea(){
            if(!this.form.bigarea){
                this.areaList = []
            }
            regAPI.commonAPI({
                id: this.form.bigarea,
                action: 'area',
                tag: 0
            }).then((res) => {
                this.areaList = res.data
            }).catch(() => {
                 this.areaList = []
            })
        },
        // 获取店租
        getShop(){
            if(!this.form.area){
                this.shopList = []
            }
            regAPI.commonAPI({
                id: this.form.area,
                action: 'shop',
                tag: 0
            }).then((res) => {
                this.shopList = res.data
            }).catch(() => {
                this.shopList = []
            })
        },
        // 切换入学时间
        handleEntranceDateChange(){
            this.form.gd = undefined
        },
        // 毕业时间不可早于入学时间
        disabledGDDate(current){
            if(!this.form.entranceDate || moment(current).isBefore(this.form.entranceDate)){
                return true
            }
            return false
        }, 
        // 切换学历信息
        handleEduInfoChange(data){
            let value = data.target.value
            Object.assign(this.form, {
                edc: value === 3 ? '军人' : undefined,
                major: undefined,
                college: undefined,
                entranceDate: undefined,
                gd: undefined,
                eduImgType: value === 3 ? 3 : 2
            })
            this.rules.major[0].message = value !== 3  ? '请输入专业': '请选择兵种'
            this.rules.college[0].message =  value !== 3  ? '请输入毕业院校': '请输入部队名称'
            this.rules.entranceDate[0].message =  value !== 3  ? '请选择入学时间': '请选择入伍时间'
             this.rules.gd[0].message =  value !== 3  ? '请选择毕业时间': '请选择退伍时间'
            this.$refs.ruleForm.clearValidate(['edc', 'college', 'entranceDate', 'gd', 'major'])

        },
        // 身份证切换
        handleCardIdChange(data){
            let val = data.target.value.trim()
            let res = vaildIdCard(val)
            if(res.code !== 0) {
                Object.assign(this.form, {
                    birth: null,
                    native: null,
                    sex: null
                })
               this.verifyCardId = false
               return false
            }
            this.verifyCardId = true
            Object.assign(this.form, {
                birth: moment(res.data.YMD),
                native: res.data.province,
                sex: res.data.sex % 2 === 0 ? 0 : 1
            })
        },
        // 年份（含）往后推6年
        getAfterYear(){
           let afterYear = []
           let beforeYear = []
          for(let i = 0; i<6;i++){
              afterYear.push(moment(this.systemTime).add(i, 'year').format('YYYY'))
              beforeYear.push(moment(this.systemTime).subtract(i, 'year').format('YYYY'))
          }  
          this.afterYear = afterYear
          this.beforeYear = beforeYear
        },
        // 获取省份
        getProvince(){
            const province = PCA[86]  
            let  provinceArr = []       
            for (const [key, value] of Object.entries(province)) {
                 provinceArr.push({
                    value:  `${key}_${value}`,
                    label: value,
                    isLeaf: false,
                 })
            }
            this.areaOptions = provinceArr
        },
        // 按需加载市
        areaLoadData(selectedOptions){
            const targetOption = selectedOptions[selectedOptions.length - 1];
            targetOption.loading = true;
            const provinceKey = targetOption.value.split('_')[0]
            const city = PCA[provinceKey]
            const cityArr = []
            for (const [key, value] of Object.entries(city)) {
                 cityArr.push({
                    value:  `${key}_${value}`,
                    label: value,
                 })
            }
            targetOption.children = cityArr;
            targetOption.loading = false;
            this.areaOptions = [...this.areaOptions];
        },
        // 添加工作经历
        handleAddWork(){
            if( this.form.works.length === 3){
                return false
            }
            this.form.works.push({})
        },
        // 删除工作经历
        handleRemoveWork(index){
            this.form.works.splice(index,1)
        },
        // 提交
        handleSub(){
            this.subLoading = true 
            this.$refs.ruleForm.validate((valid,errorObj) => {
                if(!valid) {
                    let keyArr = Object.keys(errorObj)
                    message.error((errorObj[keyArr[0]] && errorObj[keyArr[0]][0] && errorObj[keyArr[0]][0].message) || '输入信息有误')
                    this.subLoading = false
                    return false
                }
                this.subLoading = true
                // 判断学历信息
                let data = {...this.form}
                data.practice = data.eduinfo === 1 ? 1: 0
                data.soldier = data.eduinfo === 3 ? 1: 0
                if(!this.isModify){
                    data.hkaddr = `${data.hkaddr[0].split('_')[1]}-${data.hkaddr[1].split('_')[1]}`
                }
                data.birth = moment(data.birth).format('YYYY-MM-DD')
                if(data.eduinfo === 2 || data.eduinfo === 3) {
                    data.entranceDate = moment(data.entranceDate).format('YYYY-MM-DD')
                    data.gd = moment(data.gd).format('YYYY-MM-DD')
                } else {
                    data.entranceDate = data.entranceDate + '-09-01'
                    data.gd =  data.gd + '-07-31' 
                }
                if(data.works && data.works.length >= 1){
                    data.works.forEach(item => {
                        item.wbegindate = (item.time[0] && item.time[0].format('YYYY-MM-DD'))  || ''
                        item.wenddate = (item.time[1] && item.time[1].format('YYYY-MM-DD'))  || ''
                    });
                }
                if(data.jobsource === '内部推荐'){
                    data.jobdept = data.jobdept.split('&&')[1]
                    data.jobper = data.selIntroper 
                }
                if(this.shopObj && data.shop){
                    data.smg = this.shopObj.name
                    data.smgId = this.shopObj.id
                } else {
                    data.smg = ''
                    data.smgId = ''
                }
              
                data.members = [{
                  hname: data.hname,
                  hralation: data.hralation,
                  htel:data.htel
                }]
                if(this.isModify){
                    this.subModify(data)
                } else {
                    this.subReg(data)
                }
                
            });
        },
        // 修改提交
        subModify(data){
            console.log(data)
            regAPI.getData({
                    ...this.userInfo,
                    type: 2,
                    para: encodeURIComponent(JSON.stringify(data)),
                    inputcode: encodeURIComponent(data.code)
            }).then(() => {
                message.success('修改成功')
            }).catch(() => {
                
            }).then(() => {
                this.subLoading = false
            })
        },
        // 注册提交
        subReg(data){
            console.log(data)
            data.native = Cons.province[data.native]
            regAPI.subData({
                    para: encodeURIComponent(JSON.stringify(data)),
                    inputcode: encodeURIComponent(data.code)
            }).then((res) => {
                this.userInfo= res.data && res.data[0] 
                this.visible = true
            }).catch(() => {
                
            }).then(() => {
                this.subLoading = false
            })
        },
        // 确认注册
        handleRegSncSure(){
            this.visible = false
            window.location.reload()
        }
    }
}
</script>
<style lang="less" scoped>
.r-36{
    padding-right: 36px;
}
.r-10{
    padding-right: 10px;
}
.w200{
    width: 200px;
}
.w596{
    width: 596px;
}
.m-2{
    position: relative;
    left: 4px;
}
.content{
    width: 1200px;
    margin:  48px auto 166px;
    &-title{
        color: #F5AB00;
        font-size: 24px;
        padding-bottom: 16px;
        border-bottom: 1px solid #E8E8E8;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 48px;
    }
    &-p{
        font-size: 18px;
        font-weight: bold;
        position: relative;
        line-height: 1;
        margin-bottom: 26px;
        span{
            position: relative;
            z-index: 2;
        }
        &::after{
            content: '';
            position: absolute;
            width: 80px;
            height: 12px;
            background: linear-gradient(303deg, rgba(255, 212, 10, 0.12) 0%, rgba(245, 171, 0, 0.65) 100%);
            border-radius: 2px;
            overflow: hidden;
            left: 0;
            top: 8px;
            z-index: 1;
        }
        &-other{
            margin-top: 36px;
        }
    }
    /deep/ .ant-form{
        .ant-form-item-label{
            line-height: 32px;
            label{
                font-weight: bold;
            }
            > label::after{
                    margin: 0 12px 0 2px;
            }
        }
        .ant-form-item-control{
            line-height: 32px;
        }
        .ant-radio-wrapper{
            margin-right: 36px;
        }
    }
    .child-form-item{
        margin-left: 166px;
        padding: 16px 0px 16px 16px;
        background-color: #FBFBFB;
        border-radius: 2px;
        margin-bottom: 15px;
        .no-prompt{
            // /deep/ .ant-form-explain{
            //      display: none;
            // }
            // /deep/ .ant-form-item-with-help{
            //     margin-bottom: 0;
            // }
            /deep/ .ant-form-item{
                margin-bottom: 0;
            }
        }
        .last{
            padding-left: 16px;
        }
        /deep/.ant-select-selection--single .ant-select-selection__rendered{
            margin-right: 18px;
        }
    }
}
.id-card-con{
    width: 1000px;
    .prompt{
        font-size: 14px;
        color: #999999;
        margin-bottom: 11px;
    }
    .upload-con{
        display: flex;
        .item{
            margin-right: 24px;
            position: relative;
            cursor: pointer;
            // &:hover{
            //     .close{
            //         display: block;
            //     }
            // }
        }
        .close{
            position: absolute;
            right: -9px;
            top:-9px;
            width: 18px;
            height: 18px;
            font-size: 0;
            // display: none;
        }
        .close-img{
            width: 18px;
            height: 18px;
            vertical-align: top;
            
        }
    }
    .upload-btn{
        width: 140px;
        height: 140px;
        border-radius: 4px;
        border: 1px dashed #D3D3D3;
        display: flex;
        background: #FBFBFB;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        &-active{
             border: 1px dashed #ffffff;
        }
        &-img{
            width: 34px;
            margin-bottom: 20px;
            border-radius: 4px;
        }
        &-text{
            color: #CCCCCC;
            line-height: 1;
        }
        .uploaded-img{
            width: 140px;
            height: 140px;
            position: relative;
            img{
                width: 100%;
                height: 100%;
            }
            .text{
                position: absolute;
                bottom: 0;
                width: 100%;
                height: 28px;
                background-color: rgba(0, 0, 0, 0.6);
                line-height: 28px;
                text-align: center;
                color: #ffffff;
            }
        }
    }

}
.introduce-phone{
    /deep/ label{
        position: relative;
        left: -28px;
    }
    /deep/ .ant-form-item-label{
        overflow: inherit;
    }
}
.exp{
    &-item{
        display: flex;
        // margin-bottom: 20px;
        position: relative;
        width: 990px;
        &:last-child{
            margin-bottom: 0;
        }
        >div{
            margin-right: 8px;
            &:last-child{
                margin-right: 0;
            }
        }
    }
    .opt{
        position: absolute;
        cursor: pointer;
        right: -36px;
        top: 6px;
        height: 20px;
        line-height: 1;
        img{
            width: 20px;
            height: 20px;
        }
    }
}
.fall{
    // display: flex;
    // align-items: center;
   
    &-wrap{
        display: inline-block;
        position: absolute;
        left: 544px;
        top:0;
         /deep/ label{
            font-weight: normal !important;
         }
         /deep/ .ant-form-item-required::before{
             display: none;
         }
    }
    // &-title{
    //     margin-right: 8px;
    //     color: #000000;
    //     font-size: 14px;
    // }
    /deep/ input{
        border-top: none;
        border-left: none;
        border-right: none;
        border-radius: 0;
        &:focus{
            border-top: none ;
            border-left: none ;
            border-right: none ;
            box-shadow:none
        }
    }
}
.code{
    width: 83px;
    height: 32px;
    // background-color: #6589dd;
    display: inline-block;
    margin-left: 8px;
    vertical-align: middle;
    cursor: pointer;
     border-radius: 4px;
     overflow: hidden;
     vertical-align: middle;
     position: relative;
     top: -2px;
    img{
        width: 100%;
        height: 100%;
       
    }
}
.sub-btn{
    margin-top: 24px;
    /deep/ label{
        visibility: hidden;
    }
    /deep/ .ant-btn-primary{
        width:140px;
        height: 44px;
        font-size: 18px;
        background: linear-gradient(180deg, #FEBC4B 0%, #FF9A00 100%);
        &[disabled]{
            border-color: #d9d9d9;
            text-shadow: none;
            box-shadow: none;
            color: rgba(0, 0, 0, 0.25);
            background-color: #f5f5f5;
            background-image: none;
        }
    }
}
.upload-file-form{
    /deep/ .ant-form-explain{
        display: none;
    }
    .upload-con {
       /deep/ .ant-form-explain{
        display: inherit;
      }   
    }
}
.emergency-contact{
    /deep/ .ant-form-explain{
        display: none;
    }
    .emergency-contact-item {
       /deep/ .ant-form-explain{
        display: inherit;
      }   
    }
}
.reg-suc{
    display: flex;
    align-items: center;
    .text{
        margin-left: 10px;
    }
}
.shop-leader{
    position: absolute;
    left: 220px;
    width: 200px;
    top:0;
}
.tip{
    position: absolute;
    left: 210px;
    top: -6px;
    width: 480px;
    color: #999;
}
.prompt{
    margin-bottom: 24px;
    padding-top: 24px;
    padding-left: 10px;
    // margin-left: 10px;
    border-top: 1px dashed #e8e8e8;
    position: relative;
    font-weight: bold;
    color: #F5AB00;
    &::after{
        content: '';
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 8px;
        background-color: #F5AB00;
        left: 0;
        top: 31px;
    }
}
</style>